import React, { Fragment } from 'react';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import { DrawerProvider } from 'common/src/contexts/DrawerContext';
import { saasModernTheme } from 'common/src/theme/saasModern';
import { ResetCSS } from 'common/src/assets/css/style';
import { GlobalStyle, ContentWrapper } from '../containers/sassModern.style';

import Navbar from '../containers/Navbar';
import Footer from '../containers/Footer';
import DownloadShowcase from '../containers/DownloadShowcase';
import SEO from '../components/seo';
import { useTranslation } from 'react-i18next';

export default ({ pageContext }) => {
  const { t } = useTranslation();

  return (
    <ThemeProvider theme={saasModernTheme}>
      <Fragment>
        <SEO
          title={t('Download')}
          lang={pageContext.lang}
          description={t('Download clients, servers and apps of Psono!')}
        />

        <ResetCSS />
        <GlobalStyle />

        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar pageContext={pageContext} />
            </DrawerProvider>
          </Sticky>
          <DownloadShowcase pageContext={pageContext} />
          <Footer pageContext={pageContext} />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
};
